<template>
  <AppLayout wrapperClass="home" mainWrapper="home">
    <HeroBanner />
    <Login />
    <Faq />
    <Countries />
    <Contact />
  </AppLayout>
</template>

<script setup>
import AppLayout from "@/esf_venlo_base/core/components/AppLayout";
import HeroBanner from "@/esf_venlo_base/core/components/home/HeroBanner";
import Login from "@/esf_venlo_base/core/components/home/Login";
import Faq from "@/esf_venlo_base/core/components/home/Faq";
import Countries from "@/esf_venlo_base/core/components/home/Countries";
import Contact from "@/esf_venlo_base/core/components/Contact.vue";
import { computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { watch } from "vue";
const store = useStore();
const isLoggedIn = computed(() => store.getters["user/getIsLoggedIn"]);
const isApproved = computed(() => store.getters["user/getIsApproved"]);

const router = useRouter();

watch([isLoggedIn, isApproved], () => {
  if (isLoggedIn.value && isApproved.value) {
    router.push({ name: "login-home" });
  }
});
</script>